// extracted by mini-css-extract-plugin
export default {"brand_see_all_item":"style_brand_see_all_item__KiWVH","brands_img_item":"style_brands_img_item__FiX9C","nameof_brand_item":"style_nameof_brand_item__iZAjs"};